

export function detectEnterPress (e) {
  if (e.keyCode == 13) return true;
  return false;
}